<!-- ── Step 1: Confirm Quote Selection ──────────────────────────────────── -->
@if (step() === "confirm") {
  <div class="select-quote-modal">
    <div class="select-quote-modal__header">
      <h3 class="select-quote-modal__title">Select Final Quote</h3>
      <button
        type="button"
        class="select-quote-modal__close"
        (click)="onCancel()"
        aria-label="Close dialog"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M6.36436 19.0588L4.96436 17.6588L10.5644 12.0588L4.96436 6.45884L6.36436 5.05884L11.9644 10.6588L17.5644 5.05884L18.9644 6.45884L13.3644 12.0588L18.9644 17.6588L17.5644 19.0588L11.9644 13.4588L6.36436 19.0588Z"
            fill="white"
          />
        </svg>
      </button>
    </div>

    <div class="select-quote-modal__body">
      <p class="select-quote-modal__prompt">
        Are you sure you would like select {{ vendorName() }}'s final quote?
      </p>

      <!-- Card with info + breakdown -->
      <div class="select-quote-modal__card select-quote-modal__card--scrollable">
        <!-- Info row -->
        <div class="select-quote-modal__info">
          <div class="select-quote-modal__info-col">
            <span class="select-quote-modal__info-label">Delivery type</span>
            <span class="select-quote-modal__info-value">
              <svg
                class="select-quote-modal__clock-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 20 20"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M10.1839 18.3886C9.03114 18.3886 7.94781 18.1698 6.93392 17.7323C5.92003 17.2948 5.03809 16.7011 4.28809 15.9511C3.53809 15.2011 2.94434 14.3191 2.50684 13.3052C2.06934 12.2913 1.85059 11.208 1.85059 10.0552C1.85059 8.90245 2.06934 7.81912 2.50684 6.80523C2.94434 5.79134 3.53809 4.90939 4.28809 4.15939C5.03809 3.40939 5.92003 2.81564 6.93392 2.37814C7.94781 1.94064 9.03114 1.72189 10.1839 1.72189C11.3367 1.72189 12.42 1.94064 13.4339 2.37814C14.4478 2.81564 15.3298 3.40939 16.0798 4.15939C16.8298 4.90939 17.4235 5.79134 17.861 6.80523C18.2985 7.81912 18.5173 8.90245 18.5173 10.0552C18.5173 10.4302 18.4964 10.7983 18.4548 11.1594C18.4131 11.5205 18.3436 11.8747 18.2464 12.2219C18.052 11.9997 17.8263 11.8122 17.5693 11.6594C17.3124 11.5066 17.0311 11.4024 16.7256 11.3469C16.7673 11.1386 16.7985 10.9268 16.8193 10.7115C16.8402 10.4962 16.8506 10.2774 16.8506 10.0552C16.8506 8.19412 16.2048 6.61773 14.9131 5.32606C13.6214 4.03439 12.045 3.38856 10.1839 3.38856C8.32281 3.38856 6.74642 4.03439 5.45475 5.32606C4.16309 6.61773 3.51725 8.19412 3.51725 10.0552C3.51725 11.9163 4.16309 13.4927 5.45475 14.7844C6.74642 16.0761 8.32281 16.7219 10.1839 16.7219C10.8923 16.7219 11.5693 16.6177 12.2152 16.4094C12.861 16.2011 13.4548 15.9094 13.9964 15.5344C14.1631 15.7705 14.3679 15.9788 14.611 16.1594C14.8541 16.3399 15.1145 16.4788 15.3923 16.5761C14.6839 17.1455 13.8888 17.5899 13.0068 17.9094C12.1249 18.2288 11.1839 18.3886 10.1839 18.3886ZM16.2256 15.0552C15.9339 15.0552 15.6874 14.9545 15.486 14.7531C15.2846 14.5518 15.1839 14.3052 15.1839 14.0136C15.1839 13.7219 15.2846 13.4754 15.486 13.274C15.6874 13.0726 15.9339 12.9719 16.2256 12.9719C16.5173 12.9719 16.7638 13.0726 16.9652 13.274C17.1666 13.4754 17.2673 13.7219 17.2673 14.0136C17.2673 14.3052 17.1666 14.5518 16.9652 14.7531C16.7638 14.9545 16.5173 15.0552 16.2256 15.0552ZM12.9339 13.9719L9.35059 10.3886V5.88856H11.0173V9.72189L14.1006 12.8052L12.9339 13.9719Z"
                  fill="#333"
                />
              </svg>
              {{ deliveryType() }}
            </span>
          </div>
          <div class="select-quote-modal__info-col">
            <span class="select-quote-modal__info-label">Delivery date</span>
            <span
              class="select-quote-modal__info-value select-quote-modal__info-value--bold"
              >{{ deliveryDate() }}</span
            >
          </div>
          <div class="select-quote-modal__info-col">
            <span class="select-quote-modal__info-label">Quote ID</span>
            <span
              class="select-quote-modal__info-value select-quote-modal__info-value--bold"
              >{{ quoteId() }}</span
            >
          </div>
        </div>

        <!-- Cost breakdown -->
        @if (costBreakdown().length) {
          <div class="select-quote-modal__breakdown">
            @for (item of costBreakdown(); track item.concept) {
              <div class="select-quote-modal__breakdown-row">
                <span class="select-quote-modal__breakdown-concept">{{
                  item.concept === 'Translation cost' ? 'Estimated linguistic review' : item.concept
                }}</span>
                <span class="select-quote-modal__breakdown-cost">{{
                  item.cost | currency: currency()
                }}</span>
              </div>
            }
            <div class="select-quote-modal__total-row">
              <span class="select-quote-modal__total-label">Total cost</span>
              <span class="select-quote-modal__total-value">
                {{ totalCost() | currency: currency() : "symbol" : "1.2-2" }}
                {{ currency() }}
              </span>
            </div>
          </div>
        }

        <!-- Total cost -->

        <!-- 15% buffer note -->
        <p class="select-quote-modal__buffer-note">
          <strong>Note:</strong> Add a 15% buffer to your purchase order to
          account for potential adjustments in currency, tax, or review costs
          after file preparation.
        </p>

        <!-- Recommended PO Total -->
        <div class="select-quote-modal__recommended">
          <span class="select-quote-modal__recommended-label"
            >Recommended PO total</span
          >
          <span class="select-quote-modal__recommended-value">
            <span class="select-quote-modal__recommended-pct">+15%</span>=
            {{
              recommendedPOTotal() | currency: currency() : "symbol" : "1.2-2"
            }}
            {{ currency() }}
          </span>
        </div>
      </div>

      @if (errorMessage()) {
        <p class="select-quote-modal__error" role="alert">
          {{ errorMessage() }}
        </p>
      }
    </div>

    <div class="select-quote-modal__footer">
      <button
        type="button"
        class="select-quote-modal__btn select-quote-modal__btn--secondary"
        (click)="onCancel()"
        [disabled]="loading()"
      >
        Cancel
      </button>
      <button
        type="button"
        class="select-quote-modal__btn select-quote-modal__btn--primary"
        (click)="onConfirmQuote()"
        [disabled]="loading()"
      >
        Confirm
      </button>
    </div>
  </div>
}

<!-- ── Step 2: Purchase Order ID ──────────────────────────────────────── -->
@if (step() === "purchase-order") {
  <div class="select-quote-modal">
    <div class="select-quote-modal__header">
      <h2 class="select-quote-modal__title">Select Final Quote</h2>
      <button
        type="button"
        class="select-quote-modal__close"
        (click)="onCancel()"
        aria-label="Close dialog"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M6.36436 19.0588L4.96436 17.6588L10.5644 12.0588L4.96436 6.45884L6.36436 5.05884L11.9644 10.6588L17.5644 5.05884L18.9644 6.45884L13.3644 12.0588L18.9644 17.6588L17.5644 19.0588L11.9644 13.4588L6.36436 19.0588Z"
            fill="white"
          />
        </svg>
      </button>
    </div>

    <div class="select-quote-modal__body">
      <!-- Back link -->
      <button type="button" class="select-quote-modal__back" (click)="goBack()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="12"
          viewBox="0 0 8 12"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M7.41 10.59L2.83 6L7.41 1.41L6 0L0 6L6 12L7.41 10.59Z"
            fill="#D0006F"
          />
        </svg>
        Back to selected quote preview
      </button>

      <!-- DTP notice -->
      @if (isDtpJob()) {
        <p class="select-quote-modal__dtp-notice">
          Since your translation requires desktop publishing, if you cancel the
          job at any point, the vendor will charge only for any file preparation
          work that they have already completed.
        </p>
      }

      <!-- Card with info + recommended PO -->
      <div class="select-quote-modal__card">
        <!-- Info row -->
        <div class="select-quote-modal__info">
          <div class="select-quote-modal__info-col">
            <span class="select-quote-modal__info-label">Delivery type</span>
            <span class="select-quote-modal__info-value">
              <svg
                class="select-quote-modal__clock-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 20 20"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M10.1839 18.3886C9.03114 18.3886 7.94781 18.1698 6.93392 17.7323C5.92003 17.2948 5.03809 16.7011 4.28809 15.9511C3.53809 15.2011 2.94434 14.3191 2.50684 13.3052C2.06934 12.2913 1.85059 11.208 1.85059 10.0552C1.85059 8.90245 2.06934 7.81912 2.50684 6.80523C2.94434 5.79134 3.53809 4.90939 4.28809 4.15939C5.03809 3.40939 5.92003 2.81564 6.93392 2.37814C7.94781 1.94064 9.03114 1.72189 10.1839 1.72189C11.3367 1.72189 12.42 1.94064 13.4339 2.37814C14.4478 2.81564 15.3298 3.40939 16.0798 4.15939C16.8298 4.90939 17.4235 5.79134 17.861 6.80523C18.2985 7.81912 18.5173 8.90245 18.5173 10.0552C18.5173 10.4302 18.4964 10.7983 18.4548 11.1594C18.4131 11.5205 18.3436 11.8747 18.2464 12.2219C18.052 11.9997 17.8263 11.8122 17.5693 11.6594C17.3124 11.5066 17.0311 11.4024 16.7256 11.3469C16.7673 11.1386 16.7985 10.9268 16.8193 10.7115C16.8402 10.4962 16.8506 10.2774 16.8506 10.0552C16.8506 8.19412 16.2048 6.61773 14.9131 5.32606C13.6214 4.03439 12.045 3.38856 10.1839 3.38856C8.32281 3.38856 6.74642 4.03439 5.45475 5.32606C4.16309 6.61773 3.51725 8.19412 3.51725 10.0552C3.51725 11.9163 4.16309 13.4927 5.45475 14.7844C6.74642 16.0761 8.32281 16.7219 10.1839 16.7219C10.8923 16.7219 11.5693 16.6177 12.2152 16.4094C12.861 16.2011 13.4548 15.9094 13.9964 15.5344C14.1631 15.7705 14.3679 15.9788 14.611 16.1594C14.8541 16.3399 15.1145 16.4788 15.3923 16.5761C14.6839 17.1455 13.8888 17.5899 13.0068 17.9094C12.1249 18.2288 11.1839 18.3886 10.1839 18.3886ZM16.2256 15.0552C15.9339 15.0552 15.6874 14.9545 15.486 14.7531C15.2846 14.5518 15.1839 14.3052 15.1839 14.0136C15.1839 13.7219 15.2846 13.4754 15.486 13.274C15.6874 13.0726 15.9339 12.9719 16.2256 12.9719C16.5173 12.9719 16.7638 13.0726 16.9652 13.274C17.1666 13.4754 17.2673 13.7219 17.2673 14.0136C17.2673 14.3052 17.1666 14.5518 16.9652 14.7531C16.7638 14.9545 16.5173 15.0552 16.2256 15.0552ZM12.9339 13.9719L9.35059 10.3886V5.88856H11.0173V9.72189L14.1006 12.8052L12.9339 13.9719Z"
                  fill="#333"
                />
              </svg>
              {{ deliveryType() }}
            </span>
          </div>
          <div class="select-quote-modal__info-col">
            <span class="select-quote-modal__info-label">Delivery date</span>
            <span
              class="select-quote-modal__info-value select-quote-modal__info-value--bold"
              >{{ deliveryDate() }}</span
            >
          </div>
          <div class="select-quote-modal__info-col">
            <span class="select-quote-modal__info-label">Quote ID</span>
            <span
              class="select-quote-modal__info-value select-quote-modal__info-value--bold"
              >{{ quoteId() }}</span
            >
          </div>
        </div>

        <!-- Recommended PO Total -->
        <div class="select-quote-modal__recommended">
          <span class="select-quote-modal__recommended-label"
            >Recommended PO total</span
          >
          <span class="select-quote-modal__recommended-value">
            <span class="select-quote-modal__recommended-pct">+15%</span>=
            {{
              recommendedPOTotal() | currency: currency() : "symbol" : "1.2-2"
            }}
            {{ currency() }}
          </span>
        </div>
      </div>

      <!-- PO ID field (outside card) -->
      <div class="select-quote-modal__field">
        <label class="select-quote-modal__field-label" for="purchaseOrderId">
          Purchase Order ID*: 
        </label>
        <input
          id="purchaseOrderId"
          type="text"
          inputmode="numeric"
          pattern="[0-9]*"
          class="select-quote-modal__field-input"
          [ngModel]="purchaseOrderId()"
          (ngModelChange)="purchaseOrderId.set($event)"
          (keydown)="onPoKeydown($event)"
          (paste)="onPoPaste($event)"
          (drop)="onPoDrop($event)"
          (input)="onPoInput($event)"
          (blur)="poTouched.set(true)"
          maxlength="20"
          aria-required="true"
        />
        @if (poTouched() && !purchaseOrderId().trim()) {
          <p class="select-quote-modal__error" role="alert">
            Purchase Order ID is required. Maximum 20 digits, numbers only.
          </p>
        }
      </div>

      @if (errorMessage()) {
        <p class="select-quote-modal__error" role="alert">
          {{ errorMessage() }}
        </p>
      }
    </div>

    <div class="select-quote-modal__footer">
      <button
        type="button"
        class="select-quote-modal__btn select-quote-modal__btn--secondary"
        (click)="onCancel()"
        [disabled]="loading()"
      >
        Cancel
      </button>
      <button
        type="button"
        class="select-quote-modal__btn select-quote-modal__btn--primary"
        (click)="onConfirmPO()"
        [disabled]="loading() || !purchaseOrderId().trim()"
      >
        Confirm
      </button>
    </div>
  </div>
}

<!-- ── Step 3: Success Overlay ────────────────────────────────────────── -->
@if (step() === "success") {
  <div class="select-quote-modal select-quote-modal--success">
    <div class="select-quote-modal__header">
      <h2 class="select-quote-modal__title">Select Final Quote</h2>
      <button
        type="button"
        class="select-quote-modal__close"
        (click)="onDone()"
        aria-label="Close dialog"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M6.36436 19.0588L4.96436 17.6588L10.5644 12.0588L4.96436 6.45884L6.36436 5.05884L11.9644 10.6588L17.5644 5.05884L18.9644 6.45884L13.3644 12.0588L18.9644 17.6588L17.5644 19.0588L11.9644 13.4588L6.36436 19.0588Z"
            fill="white"
          />
        </svg>
      </button>
    </div>

    <div class="select-quote-modal__body select-quote-modal__body--centered">
      <div class="select-quote-modal__success-icon" aria-hidden="true">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="96"
          height="96"
          viewBox="0 0 96 96"
          fill="none"
        >
          <mask
            id="mask0_success"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="96"
            height="96"
          >
            <rect width="96" height="96" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_success)">
            <path
              d="M42.4002 66.4001L70.6002 38.2001L65.0002 32.6001L42.4002 55.2001L31.0002 43.8001L25.4002 49.4001L42.4002 66.4001ZM48.0002 88.0001C42.4669 88.0001 37.2669 86.9501 32.4002 84.8501C27.5336 82.7501 23.3002 79.9001 19.7002 76.3001C16.1002 72.7001 13.2502 68.4668 11.1502 63.6001C9.05024 58.7335 8.00024 53.5335 8.00024 48.0001C8.00024 42.4668 9.05024 37.2668 11.1502 32.4001C13.2502 27.5335 16.1002 23.3001 19.7002 19.7001C23.3002 16.1001 27.5336 13.2501 32.4002 11.1501C37.2669 9.05012 42.4669 8.00012 48.0002 8.00012C53.5336 8.00012 58.7336 9.05012 63.6002 11.1501C68.4669 13.2501 72.7002 16.1001 76.3002 19.7001C79.9002 23.3001 82.7502 27.5335 84.8502 32.4001C86.9502 37.2668 88.0002 42.4668 88.0002 48.0001C88.0002 53.5335 86.9502 58.7335 84.8502 63.6001C82.7502 68.4668 79.9002 72.7001 76.3002 76.3001C72.7002 79.9001 68.4669 82.7501 63.6002 84.8501C58.7336 86.9501 53.5336 88.0001 48.0002 88.0001ZM48.0002 80.0001C56.9336 80.0001 64.5002 76.9001 70.7002 70.7001C76.9002 64.5001 80.0002 56.9334 80.0002 48.0001C80.0002 39.0668 76.9002 31.5001 70.7002 25.3001C64.5002 19.1001 56.9336 16.0001 48.0002 16.0001C39.0669 16.0001 31.5002 19.1001 25.3002 25.3001C19.1002 31.5001 16.0002 39.0668 16.0002 48.0001C16.0002 56.9334 19.1002 64.5001 25.3002 70.7001C31.5002 76.9001 39.0669 80.0001 48.0002 80.0001Z"
              fill="#78C01E"
            />
          </g>
        </svg>
      </div>
      <h3 class="select-quote-modal__success-heading">Success!</h3>
      <p class="select-quote-modal__success-text">
        You have selected {{ vendorName() }}s final quote. The vendor will now start working on your translation.
        You will receive a notification once your job is complete.
      </p>
    </div>
  </div>
}
